export const clientConfig: Record<string, {
    hostname: string
    url: string
    urlBack: string
    telephone: string
    favicon: string
    favicon_alt: string
    title: string
    description: string
    facebook: string
    instagram: string
    tiktok: string
}> = {
    'abikebab': {
        'hostname': 'abikebab.fr',
        'url': 'https://abikebab.fr',
        'urlBack': 'https://back.abikebab.fr',
        'telephone': '04.75.80.38.79',
        "favicon": "/image/cache/catalog/43/logo/100_100_abi_logo.png",
        "favicon_alt": "Logo ABI KEBAB",
        "title": "ABI KEBAB NAN TACOS",
        "description": "Dispose d'une terrasse · Propose un menu enfant · Chiens autorisés à l'extérieur",
        "facebook": "",
        "instagram": "",
        "tiktok": ""

    },
    "Test O'King": {
        'hostname': 'localhost:5173',
        'url': 'https://localhost:5173',
        'urlBack': 'https://back.eronor.eu',
        'telephone': '01.02.03.04.05',
        "favicon": "/image/cache/catalog/15/logo/100_100_oking_logo.png",
        "favicon_alt": "Logo Test O'King",
        "title": "Test O'King",
        "description": "Dispose d'une terrasse · Propose un menu enfant · Chiens autorisés à l'extérieur",
        "facebook": "",
        "instagram": "",
        "tiktok": ""
    },
    "Test Eronor": {
        'hostname': 'dev.eronor.eu',
        'url': 'https://dev.eronor.eu',
        'urlBack': 'https://back.eronor.eu',
        'telephone': '01.02.03.04.05',
        "favicon": "/image/cache/catalog/13/logo/100_100_gout_menthe.png",
        "favicon_alt": "Logo Test Eronor",
        "title": "Test Eronor",
        "description": "Dispose d'une terrasse · Propose un menu enfant · Chiens autorisés à l'extérieur",
        "facebook": "",
        "instagram": "",
        "tiktok": ""
    },
    "Irfan Kebab": {
        'hostname': 'menuboard.fr',
        'url': 'https://menuboard.fr',
        'urlBack': 'https://back.eronor.eu',
        'telephone': '01.02.03.04.05',
        "favicon": "/image/cache/catalog/12/logo/100_100_gout_citron.png",
        "favicon_alt": "Logo Irfan Kebab",
        "title": "Irfan Kebab",
        "description": "Dispose d'une terrasse · Propose un menu enfant · Chiens autorisés à l'extérieur",
        "facebook": "",
        "instagram": "",
        "tiktok": ""
    },
    "BEST KEBAB": {
        'hostname': "bestkebabtacos.fr",
        "url": "https://bestkebabtacos.fr/",
        "urlBack": "https://back.abikebab.fr",
        'telephone': '01.02.03.04.05',
        "favicon": "/image/cache/catalog/53/logo/100_100_logo.png",
        "favicon_alt": "",
        "title": "BEST KEBAB",
        "description": "",
        "facebook": "",
        "instagram": "",
        "tiktok": ""
    },
    "MONTILIEN KEBAB": {
        'hostname': "kebabmontelimar.fr",
        "url": "https://kebabmontelimar.fr/",
        "urlBack": "https://back.abikebab.fr",
        'telephone': '0475923616',
        "favicon": "/image/cache/catalog/54/logo/100_100_logo3.png",
        "favicon_alt": "",
        "title": "MONTILIEN KEBAB",
        "description": "",
        "facebook": "",
        "instagram": "",
        "tiktok": ""
    }
    , "Aux Delices": {
        'hostname': "auxdeliceskebab.fr",
        "url": "https://auxdeliceskebab.fr/",
        "urlBack": "https://back.abikebab.fr",
        'telephone': '04 75 98 67 66',
        "favicon": "/image/cache/catalog/55/logo/100_100_logotiny.png",
        "favicon_alt": "",
        "title": "Aux Delices",
        "description": "",
        "facebook": "",
        "instagram": "",
        "tiktok": ""
    }, "Planete Pierrelatte": {
        'hostname': "kebabpierrelatte.fr",
        "url": "http://kebabpierrelatte.fr/",
        "urlBack": "https://back.abikebab.fr",
        'telephone': '04 75 46 27 83',
        "favicon": "/image/cache/catalog/39/logo/100_100_planete_w_lg.webp",
        "favicon_alt": "",
        "title": "Planete Pierrelatte",
        "description": "",
        "facebook": "https://www.facebook.com/tacos.naan.kebab",
        "instagram": "",
        "tiktok": ""
    }
}